import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DTOAccessory } from '../../../../@core/models/DTOAccessory';
import { DTOCashOnDelivery } from '../../../../@core/models/DTOCashOnDelivery';
import { DTOCustomerInfo } from '../../../../@core/models/DTOCustomerInfo';
import { DTODestination } from '../../../../@core/models/DTODestination';
import { DTOSender } from '../../../../@core/models/DTOSender';
import { DTOShipment } from '../../../../@core/models/DTOShipment';
import { DTOShipmentCreate } from '../../../../@core/models/DTOShipmentCreate';
import { ShipmentService } from '../../../../@core/services/shipment.service';
import { CrmClientLookupDialogComponent } from '../dialogs/crm-client-lookup-dialog/crm-client-lookup-dialog.component';
import { CryptoService } from '../../../../@core/services/encrypt.service';

interface Option {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'crm-create-shipment',
  templateUrl: './crm-create-shipment.component.html',
  styleUrls: ['./crm-create-shipment.component.scss']
})
export class CrmCreateShipmentComponent implements OnInit, AfterViewInit {
  @ViewChild('shipmentForm', null) shipmentForm: NgForm;

  sub: Subscription;
  shipment: DTOShipment;
  shipmentCreate: DTOShipmentCreate;
  waybill: string;
  userId: string;
  lang: string;
  key: string;
  encryptedKey: string;
  searchButton;
  error: string;

  customerId: number;
  customerName: string;
  shipmentId: number;
  expeditionDate: string;
  shipmentType: string;
  totalParcels: number;
  totalWeight: number;
  referenceNumber: string;
  customBarcode: string;
  note: string;
  billingAccount: number;

  /*
   * Sender
   */
  senderContact: string;
  senderAccountNumber: string;
  senderAccountName: string;
  senderAddress1: string;
  senderAddress2: string;
  senderPostalCode: string;
  senderCity: string;
  senderProvinceState: string;
  senderPhone: string;
  senderSmsNotification: boolean = false;
  senderEmailNotification: boolean = false;
  senderNoCivic: string;
  senderSuite: string;
  senderStreetName: string;
  senderEmail: string;
  senderDeliveryDays: string[];
  senderDepotShort: string;
  senderSectorId: number;
  senderRouteId: number;

  /*
   * Destination
   */
  destContact: string;
  destAccountNumber: string;
  destAccountName: string;
  destAddress1: string;
  destAddress2: string;
  destPostalCode: string;
  destCity: string;
  destProvinceState: string;
  destPhone: string;
  destSmsNotification: boolean = false;
  destEmailNotification: boolean = false;
  destNoCivic: string;
  destSuite: string;
  destStreetName: string;
  destEmail: string;
  destDeliveryDays: string[];
  destDepotShort: string;
  destSectorId: number;
  destRouteId: number;

  /**
   * Accessory
   */
  accInsuranceAmount?: number;
  accFrozenProtection?: boolean;
  accDangerousGoods?: boolean;
  accBefore10h30am?: boolean;
  accSNR: boolean;

  /**
   * CashOnDelivery
   */
  codType: string;
  codAmount: number;

  codOptions: Option[] = [];

  tempCustomerId: number;
  tempSenderAccountNumber: string;
  tempCustomerName: string;
  tempSenderPostalCode: string;
  tempSenderAddress1: string;
  tempSenderAddress2: string;
  tempSenderCity: string;
  tempSenderPhone: string;

  tSenderAccountNumber: string;
  tCustomerName: string;
  tSenderPostalCode: string;
  tSenderAddress1: string;
  tSenderAddress2: string;
  tSenderCity: string;
  tSenderPhone: string;

  /**
   *
   * @param _shipmentService
   * @param _translateService
   * @param route
   * @param dialog
   */

  constructor(
    private _shipmentService: ShipmentService,
    public _translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    public shipmentService: ShipmentService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private readonly cryptoService: CryptoService
  ) {}

  async ngAfterViewInit(): Promise<void> {
    await this._translateService.get('dummyTranslation').toPromise().then();
    let none = this._translateService.instant('crm.lbl-none');
    this.codOptions = [
      {
        value: 'NoCOD',
        viewValue: none
      },
      {
        value: 'Check',
        viewValue: this._translateService.instant('crm.lbl-cash-or-check')
      },
      {
        value: 'Cash',
        viewValue: this._translateService.instant('crm.lbl-cash-only')
      },
      {
        value: 'PostDatedCheck',
        viewValue: this._translateService.instant('crm.lbl-postdated-check')
      },
      {
        value: 'CertifiedCheck',
        viewValue: this._translateService.instant('crm.lbl-certified-check')
      }
    ];
  }

  async ngOnInit() {

    const querystringParams = new URLSearchParams(window.location.search);
    
    this.userId = querystringParams.get('userId');
    this.encryptedKey = querystringParams.get('key');

    const decryptedKey = await this.cryptoService.decryptBase64(this.encryptedKey, "let encrypt = this.encryptService.encrypt(chaine);")
    this.key = decryptedKey;

    this.lang = querystringParams.get('UserLanguage');
    
    if (this.lang === '1033') {
      this._translateService.use('en');
    } else if ((this.lang = '1036')) {
      this._translateService.use('fr');
    }
    this.codType = 'NoCOD';
    this.shipmentType = 'Delivery';
    this.expeditionDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.totalParcels = 1;
    this.totalWeight = 1;
  }

  clientLookup() {
    const dialogRef = this.dialog.open(CrmClientLookupDialogComponent, {
      width: '800px',
      height: '500px',
      position: { top: '100px' },
      data: {
        userId: this.userId,
        key: this.key
      }
    });
    dialogRef.afterClosed().subscribe((res: DTOCustomerInfo) => {
      if (res !== null) {
        this.customerId = res.CustomerId;
        this.senderAccountNumber = res.CustomerId.toString();
        this.customerName = res.Name;
        this.senderPostalCode = res.PostalCode;
        this.senderAddress1 = res.Address1;
        this.senderAddress2 = res.Address2;
        this.senderCity = res.City;
        this.senderPhone = res.Phone;

        this.tempCustomerId = res.CustomerId;
        this.tempSenderAccountNumber = res.CustomerId.toString();
        this.tempCustomerName = res.Name;
        this.tempSenderPostalCode = res.PostalCode;
        this.tempSenderAddress1 = res.Address1;
        this.tempSenderAddress2 = res.Address2;
        this.tempSenderCity = res.City;
        this.tempSenderPhone = res.Phone;
      }
    });
  }

  searchClient(event: any) {
    console.log(event);
    this.shipmentService
      .SearchCustomer(event, this.userId, this.key)
      .subscribe((res) => {
        if (res.length === 1) {
          this.customerId = res[0].CustomerId;
          this.senderAccountNumber = res[0].CustomerId.toString();
          this.customerName = res[0].Name;
          this.senderPostalCode = res[0].PostalCode;
          this.senderAddress1 = res[0].Address1;
          this.senderAddress2 = res[0].Address2;
          this.senderCity = res[0].City;
          this.senderPhone = res[0].Phone;

          this.tempCustomerId = this.customerId;
          this.tempSenderAccountNumber = this.senderAccountNumber;
          this.tempCustomerName = this.customerName;
          this.tempSenderPostalCode = this.senderPostalCode;
          this.tempSenderAddress1 = this.senderAddress1;
          this.tempSenderAddress2 = this.senderAddress2;
          this.tempSenderCity = this.senderCity;
          this.tempSenderPhone = this.senderPhone;
        }
      });
  }

  clear() {
    this.senderAccountNumber = null;
    this.customerName = null;
    this.senderAddress1 = null;
    this.senderAddress2 = null;
    this.senderPostalCode = null;
    this.senderCity = null;
    this.senderPhone = null;
    this.destAccountNumber = null;
    this.destAccountName = null;
    this.destAddress1 = null;
    this.destAddress2 = null;
    this.destPostalCode = null;
    this.destCity = null;
    this.destPhone = null;
    this.senderEmail = null;
    this.codType = null;
    this.codAmount = null;
    this.accInsuranceAmount = null;
    this.accFrozenProtection = null;
    this.accDangerousGoods = null;
    this.accBefore10h30am = null;
    this.accSNR = null;
    this.customerId = null;
    this.expeditionDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.shipmentType = 'Delivery';
    this.totalParcels = null;
    this.totalWeight = null;
    this.referenceNumber = null;
    this.customBarcode = null;
    this.note = null;
    this.billingAccount = null;
  }

  shipmentTypeChange(event: any) {
    
    switch (event.value) {
      case 'Delivery':
        this.shipmentForm.resetForm(this.shipmentForm.value);

        this.customerId = this.tempCustomerId;
        this.senderAccountNumber = this.tempSenderAccountNumber;
        this.customerName = this.tempCustomerName;
        this.senderPostalCode = this.tempSenderPostalCode;
        this.senderAddress1 = this.tempSenderAddress1;
        this.senderAddress2 = this.tempSenderAddress2;
        this.senderCity = this.tempSenderCity;
        this.senderPhone = this.tempSenderPhone;
      
        this.destAccountNumber = null;
        this.destAccountName = null;
        this.destAddress1 = null;
        this.destAddress2 = null;
        this.destPostalCode = null;
        this.destCity = null;
        this.destPhone = null;
        break;
      case 'PickupReturn':

        this.tSenderAccountNumber = this.senderAccountNumber;
        this.tCustomerName = this.customerName;
        this.tSenderAddress1 = this.senderAddress1;
        this.tSenderAddress2 = this.senderAddress2;
        this.tSenderPostalCode = this.senderPostalCode;
        this.tSenderCity = this.senderCity;
        this.tSenderPhone = this.senderPhone;

        this.shipmentForm.resetForm(this.shipmentForm.value);
        
        this.destAccountNumber = this.tSenderAccountNumber;
        this.destAccountName = this.tCustomerName;
        this.destAddress1 = this.tSenderAddress1;
        this.destAddress2 = this.tSenderAddress2;
        this.destPostalCode = this.tSenderPostalCode;
        this.destCity = this.tSenderCity;
        this.destPhone = this.tSenderPhone;
        
        this.senderPostalCode = null;
        this.senderAddress1 = null;
        this.senderAddress2 = null;
        this.senderCity = null;
        this.senderPhone = null;
        break;
      case 'PickupDelivery':
        this.customerId = this.tempCustomerId;
        this.senderAccountNumber = this.tempSenderAccountNumber;
        this.customerName = this.tempCustomerName;
        this.senderPostalCode = this.tempSenderPostalCode;
        this.senderAddress1 = this.tempSenderAddress1;
        this.senderAddress2 = this.tempSenderAddress2;
        this.senderCity = this.tempSenderCity;
        this.senderPhone = this.tempSenderPhone;
        break;
    }
  }

  onSubmit() {
    let sender: DTOSender = {
      AccountNumber: this.senderAccountNumber,
      AccountName: this.customerName,
      Address1: this.senderAddress1,
      Address2: this.senderAddress2,
      PostalCode: this.senderPostalCode,
      City: this.senderCity,
      Phone: this.senderPhone,
      SmsNotification: this.senderSmsNotification,
      EmailNotification: this.senderEmailNotification,
      Email: this.senderEmail
    };

    let destination: DTODestination = {
      AccountNumber: this.destAccountNumber,
      AccountName: this.destAccountName,
      Address1: this.destAddress1,
      Address2: this.destAddress2,
      PostalCode: this.destPostalCode,
      City: this.destCity,
      Phone: this.destPhone
    };

    let cashOnDelivery: DTOCashOnDelivery = {
      CODType: this.codType,
      CODAmount: this.codAmount
    };

    let accessory: DTOAccessory = {
      InsuranceAmount: this.accInsuranceAmount,
      FrozenProtection: this.accFrozenProtection,
      DangerousGoods: this.accDangerousGoods,
      Before10h30am: this.accBefore10h30am,
      SNR: this.accSNR,
      COD: cashOnDelivery
    };

    let dtoShipmentCreate: DTOShipmentCreate = {
      CustomerId: this.customerId,
      ShipmentId: -2,
      ExpeditionDate: this.expeditionDate,
      ShipmentType: this.shipmentType,
      TotalParcels: this.totalParcels,
      TotalWeight: this.totalWeight,
      ReferenceNumber: this.referenceNumber,
      CustomBarcode: this.customBarcode,
      Note: this.note,
      BillingAccount: this.billingAccount,
      Sender: sender,
      Destination: destination,
      Accessory: accessory
    };

    this._shipmentService
      .CreateShipment(dtoShipmentCreate, this.userId, this.key)
      .subscribe((res) => {
        this.toastrService.success(
          this._translateService.instant('Status'),
          this._translateService.instant('crm.lbl-shipment-created'),
          {
            positionClass: 'toast-top-center',
            disableTimeOut: false,
            enableHtml: true
          }
        );
        this.router.navigate(['/crm'], {
          queryParams: {
            userId: this.userId,
            key: this.encryptedKey,
            UserLanguage: this.lang,
            waybill: res.ShipmentId
          }
        });
      });
  }
}
